import React from 'react';


function CallForSupport(props:any) {
    return (
        <a className="btn btn-try-builder btn-bg-gradient-x-purple-red btn-glow white mb-1"
           href="https://multipixeltec.com/contact-us/" target="_blank"  rel="noreferrer">
            CALL FOR SUPPORT
        </a>
    );
}

export default CallForSupport;
